module.exports = __webpack_public_path__ + "img/p1-active.9e1031b8.png";